import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Flex, Spinner, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Gate for pages meant only for signed-out visitors.
 *
 * Waits for `loading` before deciding, which `ProtectedRoute` already did and
 * this did not. Without it, `user` is still null while the refresh cookie is
 * being redeemed, so someone with a perfectly good session who lands on /login
 * sees it render for a moment before being bounced — a flash of the one screen
 * they should never have to look at again.
 */
const PublicRoute = () => {
  const { user, loading } = useAuth();
  const { t } = useTranslation('common');

  if (loading) {
    return (
      <Flex
        minHeight="100vh"
        align="center"
        justify="center"
        direction="column"
        gap={4}
        bg="redesign.bg.page"
      >
        <Spinner size="xl" color="redesign.accent.blue" thickness="4px" />
        <Text color="redesign.text.muted">{t('states.loading')}</Text>
      </Flex>
    );
  }

  return user ? <Navigate to="/" replace /> : <Outlet />;
};

export default PublicRoute;
